import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "evaluate"
};
var _hoisted_2 = {
  key: 0,
  class: "center"
};
var _hoisted_3 = {
  key: 0,
  class: "evaluate-loading"
};
var _hoisted_4 = {
  class: "ping-evaluate"
};
var _hoisted_5 = {
  class: "ping-evaluate-class flex-center"
};
var _hoisted_6 = {
  class: "tdesign-demo-dropdown__text"
};
var _hoisted_7 = {
  class: "school"
};
var _hoisted_8 = {
  class: "ping-evaluate-cycle"
};
var _hoisted_9 = {
  key: 2,
  class: "center"
};
import { ref, onMounted, computed } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { getPadOptionCycle, getUserInfos, getPermissionCheck, getAcceptInfo, setSwitchClasses } from '@/api/index-ping';
import { routeAuth } from '@/utils/auth';
import { ChevronDownIcon } from 'tdesign-icons-vue-next';
import periodSwitch from '@/components/PeriodSwitch';
import ClassName from './Class.vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var loading = ref(true);
    var hasAuth = ref(false);
    var permission = ref(null);
    var periodLoading = ref(false);
    var columns = ref([]);
    var periodId = ref(''); // 周期ID
    var options = ref([]);
    var acceptInfo = ref({}); // 班级报告个人信息
    var loadingS = ref(false);
    // 获取班级
    var getClassName = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _data$data$classMsg, _yield$getUserInfos, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return getUserInfos();
            case 1:
              _yield$getUserInfos = _context.v;
              data = _yield$getUserInfos.data;
              options.value = (_data$data$classMsg = data.data.classMsg) === null || _data$data$classMsg === void 0 ? void 0 : _data$data$classMsg.map(function (item) {
                return {
                  content: item.className,
                  value: item.classId,
                  type: item.classType
                };
              });
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              (_t === null || _t === void 0 ? void 0 : _t.message) && MessagePlugin.warning(_t === null || _t === void 0 ? void 0 : _t.message);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function getClassName() {
        return _ref.apply(this, arguments);
      };
    }();
    // 获取班级验收报告详情
    var acceptInfoData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var query, _yield$getAcceptInfo, data, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              query = {
                type: 'class'
              };
              _context2.p = 1;
              _context2.n = 2;
              return getAcceptInfo(query);
            case 2:
              _yield$getAcceptInfo = _context2.v;
              data = _yield$getAcceptInfo.data;
              acceptInfo.value = data.data;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              MessagePlugin.warning('暂无班级报告');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      }));
      return function acceptInfoData() {
        return _ref2.apply(this, arguments);
      };
    }();
    // 获取时间
    var getOptionCycle = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _data$data, _yield$getPadOptionCy, data, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              periodLoading.value = true;
              _context3.n = 1;
              return getPadOptionCycle();
            case 1:
              _yield$getPadOptionCy = _context3.v;
              data = _yield$getPadOptionCy.data;
              columns.value = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.map(function (item) {
                return {
                  content: item.option,
                  value: item.value,
                  isCurrentCycle: item.isCurrentCycle
                };
              });
              periodId.value = columns.value[0].value;
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              MessagePlugin.warning('暂无周期');
            case 3:
              _context3.p = 3;
              periodLoading.value = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2, 3, 4]]);
      }));
      return function getOptionCycle() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 无权限提示
    // eslint-disable-next-line vue/return-in-computed-property
    var notPermissionText = computed(function () {
      if (!hasAuth.value) {
        return '暂无应用权限';
      } else {
        var _permission$value = permission.value,
          classFlag = _permission$value.classFlag,
          projectFlag = _permission$value.projectFlag;
        if (classFlag === 1) {
          return '尚未加入班级，无法参与评价';
        }
        if (classFlag === 0 && projectFlag === 1) {
          return '当前年级尚未配置综合素质评价，请联系管理员';
        }
      }
    });

    // 评价项目权限
    var evaluateAuth = computed(function () {
      var _permission$value2 = permission.value,
        classFlag = _permission$value2.classFlag,
        projectFlag = _permission$value2.projectFlag;
      if (classFlag === 1) {
        return false;
      } else if (classFlag === 0 && projectFlag === 1) {
        return false;
      } else {
        return true;
      }
    });

    // 应用权限检查
    var appAliasEvent = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var auth, _t4, _t5;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              loading.value = true;
              _context4.n = 1;
              return routeAuth('comprehensiveEvaluate');
            case 1:
              auth = _context4.v;
              _t4 = auth;
              if (!_t4) {
                _context4.n = 2;
                break;
              }
              _context4.n = 2;
              return permissionCheck();
            case 2:
              hasAuth.value = auth;
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t5 = _context4.v;
              MessagePlugin.warning('权限检查异常');
            case 4:
              _context4.p = 4;
              loading.value = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 3, 4, 5]]);
      }));
      return function appAliasEvent() {
        return _ref4.apply(this, arguments);
      };
    }();

    // 获取权限
    var permissionCheck = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$getPermissionC, data, _data$data2, classFlag, projectFlag, _t6;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              loadingS.value = true;
              _context5.n = 1;
              return getPermissionCheck();
            case 1:
              _yield$getPermissionC = _context5.v;
              data = _yield$getPermissionC.data;
              _data$data2 = data.data, classFlag = _data$data2.classFlag, projectFlag = _data$data2.projectFlag;
              permission.value = data.data;
              if (!(classFlag === 0 && projectFlag === 0)) {
                _context5.n = 4;
                break;
              }
              _context5.n = 2;
              return getClassName();
            case 2:
              _context5.n = 3;
              return acceptInfoData();
            case 3:
              _context5.n = 4;
              return getOptionCycle();
            case 4:
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t6 = _context5.v;
              MessagePlugin.warning('获取数据失败');
            case 6:
              _context5.p = 6;
              loadingS.value = false;
              return _context5.f(6);
            case 7:
              return _context5.a(2);
          }
        }, _callee5, null, [[0, 5, 6, 7]]);
      }));
      return function permissionCheck() {
        return _ref5.apply(this, arguments);
      };
    }();
    // 更改时间周期
    var changePeriod = function changePeriod(val) {
      periodId.value = val;
    };
    // 更改班级
    var changeClass = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(option) {
        var currentClass, _yield$setSwitchClass, data, _data$data3, classFlag, projectFlag;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              currentClass = {
                classId: option.value,
                className: option.content,
                classType: option.type
              };
              _context6.n = 1;
              return setSwitchClasses(currentClass);
            case 1:
              _yield$setSwitchClass = _context6.v;
              data = _yield$setSwitchClass.data;
              _data$data3 = data.data, classFlag = _data$data3.classFlag, projectFlag = _data$data3.projectFlag;
              if (classFlag === 0 && projectFlag === 0) {
                getClassName();
                acceptInfoData();
                getOptionCycle();
                MessagePlugin.success('班级切换成功');
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      return function changeClass(_x) {
        return _ref6.apply(this, arguments);
      };
    }();
    onMounted(function () {
      appAliasEvent();
    });
    return function (_ctx, _cache) {
      var _component_Loading = _resolveComponent("Loading");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_dropdown = _resolveComponent("t-dropdown");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loading)])) : _createCommentVNode("", true), !loading.value && hasAuth.value && evaluateAuth.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [loadingS.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_Loading), _cache[0] || (_cache[0] = _createTextVNode(" 正在加载中... ", -1))])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_t_dropdown, {
        options: options.value,
        onClick: changeClass
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_button, {
            variant: "text"
          }, {
            default: _withCtx(function () {
              var _acceptInfo$value;
              return [_createElementVNode("span", _hoisted_6, [_createTextVNode(_toDisplayString((_acceptInfo$value = acceptInfo.value) === null || _acceptInfo$value === void 0 ? void 0 : _acceptInfo$value.className) + " ", 1), _createVNode(_unref(ChevronDownIcon), {
                size: "16"
              })])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["options"]), _createElementVNode("span", _hoisted_7, _toDisplayString(acceptInfo.value.schoolName || '--'), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(periodSwitch), {
        loading: periodLoading.value,
        columns: columns.value,
        onChange: changePeriod
      }, null, 8, ["loading", "columns"])])]), _createVNode(ClassName, {
        "period-id": periodId.value,
        columns: columns.value
      }, null, 8, ["period-id", "columns"])], 64))], 64)) : _createCommentVNode("", true), !loading.value && (!hasAuth.value || !evaluateAuth.value) ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_Empty, {
        text: notPermissionText.value
      }, null, 8, ["text"])])) : _createCommentVNode("", true)]);
    };
  }
};